import { Col, Row } from "antd";
import { Header } from "antd/lib/layout/layout";
import MenuComponent from "./menu.component";
import ProfileMenuComponent from "./profile-menu.component";
type Props = {};
const HeaderComponent: React.FC<Props> = () => {
  return (
    <>
      <Header className="panel-header">
        <Row gutter={16} align="middle" className="header-row">
          <Col xs={16} sm={16} md={3}>
            <div className="sidebar-logo-wrapper">
            <img alt="logo" src={`https://roboticodigital.com/assets/images/logo/robotico-logo(white)-01.svg`} />
              <h1 className="sidebar-logo" style={{color: 'White', fontWeight: 'bold'}}>Robotico Digital</h1>
              {/* <img alt="logo" src={`assets/images/logo-placeholder.png`} /> */}
            </div>
          </Col>
          <Col xs={4} sm={4} md={19}>
            <MenuComponent />
          </Col>
          <Col xs={4} sm={4} md={2} className="text-right">
            <ProfileMenuComponent />
          </Col>
        </Row>
      </Header>
    </>
  );
};
export default HeaderComponent;
